export const ACCESS_TOKEN_KEY = 'gold_trading_access_token';
